import produce from 'immer'
import { safeDeepUpdate } from '@jarvis.oddle/core/tools/object'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import {
  updateForAsyncRequest,
  updateForAsyncSuccess,
  updateForAsyncFailure
} from '@jarvis.oddle/core/tools/redux/reducer'
import * as C from './constants'

export const initialState = createAsyncObject({
  themeSettingData: {
    settings: {}
  },
  sectionSettingData: {
    sections: {},
    pages: {
      index: []
    }
  },
  siteSettingData: {},
  sortingSectionOrder: [],
  sortingSectionId: '',
  currentAction: {},
  previewMode: false
})

export const reducers = (state = initialState, action) =>
  produce(state, (draftState) => {
    switch (action.type) {
      case C.UPDATE_CUSTOMISATION_SETTING: {
        const {
          themeSettingData,
          sectionSettingData,
          sortingSectionOrder,
          sortingSectionId,
          currentAction
        } = action.payload
        safeDeepUpdate(draftState.data, ['themeSettingData'], themeSettingData)
        safeDeepUpdate(
          draftState.data,
          ['sectionSettingData'],
          sectionSettingData
        )
        safeDeepUpdate(
          draftState.data,
          ['sortingSectionOrder'],
          sortingSectionOrder
        )
        safeDeepUpdate(draftState.data, ['sortingSectionId'], sortingSectionId)
        safeDeepUpdate(draftState.data, ['currentAction'], currentAction)
        break
      }
      case C.LOAD_PREVIEW_THEME_REQUEST:
      case C.LOAD_THEME_REQUEST:
        updateForAsyncRequest(draftState)
        break
      case C.LOAD_PREVIEW_THEME_SUCCESS:
      case C.LOAD_THEME_SUCCESS:
        updateForAsyncSuccess((_draftState) => {
          _draftState.data.themeSettingData =
            action.payload.themeData.themeSettingData
          _draftState.data.sectionSettingData =
            action.payload.themeData.sectionSettingData
          _draftState.data.siteSettingData =
            action.payload.themeData.siteSettingData
        })(draftState)
        break
      case C.LOAD_PREVIEW_THEME_FAILURE:
      case C.LOAD_THEME_FAILURE:
        updateForAsyncFailure(action)(draftState)
        break
      case C.SET_PREVIEW_MODE:
        draftState.data.previewMode = action.payload.previewMode
        break
    }
  })
